"use client";

import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react"; // Icons for expand/collapse

const TandCListComp = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="p-2 w-3/8 md:w-3/4 mx-auto bg-white rounded-lg md:rounded-xl">
      {/* Header with Toggle Button */}
      <div className="flex justify-between items-center cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
        <h1 className="text-sm md:text-xl font-bold text-gray-900">Terms & Conditions</h1>
        {isOpen ? <ChevronUp className="w-6 h-6 text-gray-700" /> : <ChevronDown className="w-6 h-6 text-gray-700" />}
      </div>

      {/* Bullet List - Shown Only When isOpen is True */}
      {isOpen && (
        <ul className="list-disc list-inside text-gray-700 space-y-3 mt-2">
          <li>Payment is to be paid upon booking your slot to secure your appointment.</li>
          <li>Clients receive a full refund if the session is cancelled more than 48 hours prior to their appointment.</li>
          <li>You will receive your tailored plan within 7 working days.</li>
          <li>We are unable to send your plan over until the appropriate forms are signed.</li>
          <li>
            For the best results, please fill in your ‘Food, Mood & Poo Diary’ pre-appointment and email it back to us 
            with any other functional tests you would like us to go through on your consultation.
          </li>
          <li>
            To enable us to give you the best continued support, please refrain from communicating with us through texts. 
            Instead, make a list of your questions, and we can run through any queries during your follow-up. 
            Here, all your queries, results, and updated recommendations will be logged to better monitor your health status.
          </li>
          <li>
            We are Naturopathic Nutritionists (CNM/ANP registered), and as such can only advise you. 
            We are by no means doctors. You may want to consult your physician before making any changes to your diet or lifestyle.
          </li>
        </ul>
      )}
    </div>
  );
};

export default TandCListComp;
